import { Box, TextField } from '@mui/material';
import { useState } from 'react';
import { roundedOtpFieldSx } from '../shared/authFieldStyles';

const OtpInput = () => {
  const [otp, setOtp] = useState(Array(4).fill(''));

  const handleOtpChange = (index, value) => {
    const updatedOtp = [...otp];
    updatedOtp[index] = value.slice(-1);
    setOtp(updatedOtp);
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  return (
    <Box display="flex" justifyContent="center" marginTop={2}>
      {otp.map((digit, index) => (
        <TextField
          key={index}
          id={`otp-input-${index}`}
          value={digit}
          onChange={(e) => handleOtpChange(index, e.target.value)}
          sx={{ ...roundedOtpFieldSx, margin: '0 5px' }}
          inputProps={{ maxLength: 1, style: { textAlign: 'center', fontSize: '24px' } }}
        />
      ))}
    </Box>
  );
};

export default OtpInput;
